import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { bookingShape, historyDetailShape } from 'constants/propTypes';

import { Container, ActionHeader, ActionContent, AuditInfo, HeaderToggle, HeaderToggleWrapper } from './HistoryDetail.styles';

import HistoryActionContent from './HistoryActionContent';
import { getActionName } from './HistoryDetails.utils';

const ACTION_TYPE_TRANSLATION_KEYS = {
  'TICKETS CONFIRMED': 'history.action_type.tickets_confirmed',
  'TICKETS PUT ON-HOLD WITHOUT DEPOSIT': 'history.action_type.tickets_on_hold_without_deposit',
  'TICKETS PUT ON-HOLD WITH DEPOSIT': 'history.action_type.tickets_on_hold_with_deposit',
  'TICKETS AFTERSALES': 'history.action_type.tickets_aftersales',
  'ADD PASSENGER': 'history.action_type.add_passenger',
  'SEAT CHANGE': 'history.action_type.seat_change',
  'PASSENGER UPDATE': 'history.action_type.passenger_update',
  PAYMENT: 'history.action_type.payment',
  'TICKETS CHECKED IN': 'history.action_type.tickets_checked_in',
  'TICKETS CHECKED OUT': 'history.action_type.tickets_checked_out',
  'TICKETS VALIDATED': 'history.action_type.tickets_validated',
  'TICKETS WITH VALIDATION VOIDED': 'history.action_type.tickets_validation_voided',
  'AGENT NOTE': 'history.action_type.agent_note',
  'SCHEDULE CHANGE': 'history.action_type.schedule_change',
  OTHER: 'history.action_type.other'
};

const HistoryDetail = ({ booking, detail }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [shouldTransition, setShouldTransition] = useState(false);
  const [height, setHeight] = useState(0);

  const contentEl = React.createRef();

  useEffect(() => {
    if (!contentEl.current || height !== 0) {
      return;
    }

    const computedHeight = window.getComputedStyle(contentEl.current).height;
    setHeight(computedHeight);

    setIsOpen(false);
    setShouldTransition(true);
  }, [contentEl, height]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const actionName = getActionName(detail.revisionContents, detail.actionType, detail.data.tickets);
  const actionTypeTranslationKey = ACTION_TYPE_TRANSLATION_KEYS[actionName];

  return (
    <Container data-cy="history-detail">
      {detail.data.bookingItemsActions.length === 0 && detail.data.content === '' ? null : (
        <ActionHeader onClick={toggle}>
          <HeaderToggleWrapper>
            {detail.actions && (detail.actions.length > 0 || detail?.data?.content) && <HeaderToggle isExpanded={isOpen} />}
          </HeaderToggleWrapper>
          <div data-cy="history-detail-action-type">
            <FormattedMessage id={actionTypeTranslationKey} defaultMessage={actionName} />
          </div>
          <AuditInfo>
            <strong>{moment(detail.date).format('Do MMMM YYYY [at] HH:mm')}</strong>{' '}
            <span>
              {detail.username}
              {detail.office && ` (${detail.office})`}
            </span>
          </AuditInfo>
        </ActionHeader>
      )}

      {detail.actions && (detail.actions.length > 0 || detail?.data?.content) && (
        <ActionContent height={height} shouldTransition={shouldTransition} isExpanded={isOpen} ref={contentEl}>
          <HistoryActionContent booking={booking} detail={detail} />
        </ActionContent>
      )}
    </Container>
  );
};

HistoryDetail.propTypes = {
  booking: bookingShape,
  detail: historyDetailShape.isRequired
};

export default HistoryDetail;
